import { FeatureType, FeatureVisualData } from './featureVisuals';

export { FeatureType } from './featureVisuals';

export const FeatureData = {
	[FeatureType.CASES]: {
		titleKey: 'common.features.cases',
		name: 'cases',
		...FeatureVisualData[FeatureType.CASES],
	},
	[FeatureType.AML]: {
		titleKey: 'common.features.aml',
		name: 'aml',
		...FeatureVisualData[FeatureType.AML],
	},
	[FeatureType.FORMS]: {
		titleKey: 'common.features.forms',
		name: 'forms',
		...FeatureVisualData[FeatureType.FORMS],
	},
	[FeatureType.PROOF_OF_ADDRESS]: {
		titleKey: 'common.features.poa',
		name: 'poa',
		...FeatureVisualData[FeatureType.PROOF_OF_ADDRESS],
	},
	[FeatureType.ENTITY]: {
		titleKey: 'common.features.entity',
		name: 'entity',
		...FeatureVisualData[FeatureType.ENTITY],
	},
	[FeatureType.FLOWS]: {
		titleKey: 'common.sidebar.menu.flows',
		name: 'flows',
		...FeatureVisualData[FeatureType.FLOWS],
	},
};

export const Feature = {
	get(feature: FeatureType) {
		return FeatureData[feature];
	},
	color(feature: FeatureType) {
		return FeatureData[feature].color;
	},
	icon(feature: FeatureType) {
		return FeatureData[feature].icon;
	},
};

export const AMLFeature = Feature.get(FeatureType.AML);
export const CasesFeature = Feature.get(FeatureType.CASES);
export const FormsFeature = Feature.get(FeatureType.FORMS);
export const PoaFeature = Feature.get(FeatureType.PROOF_OF_ADDRESS);
export const EntityFeature = Feature.get(FeatureType.ENTITY);
export const FlowsFeature = Feature.get(FeatureType.FLOWS);
